import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { IconTooltipComponent } from './icon-tooltip.component';
import { TooltipModule } from '@finder/shared/components/tooltip/tooltip.module';
import { FontIconModule } from '@finder/shared/components/font-icon/font-icon.module';

@NgModule({
    imports: [
        CommonModule,
        TooltipModule,
        FontIconModule,
    ],
    declarations: [
        IconTooltipComponent,
    ],
    providers: [],
    exports: [
        IconTooltipComponent,
    ]
})
export class IconTooltipModule {}
